import { render, staticRenderFns } from "./station_main_wincc.vue?vue&type=template&id=a56f4862&scoped=true"
import script from "./station_main_wincc.vue?vue&type=script&lang=js"
export * from "./station_main_wincc.vue?vue&type=script&lang=js"
import style0 from "./station_main_wincc.vue?vue&type=style&index=0&id=a56f4862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56f4862",
  null
  
)

export default component.exports